import { optimizelyClient } from '~/utils/featureflags/FeatureFlagsProvider';

export const track = <T extends object>(eventKey: string, eventProps?: T) => {
  if (!optimizelyClient.isReady()) return;

  // custom event props need to be passes separately from the default props
  // https://docs.developers.optimizely.com/feature-experimentation/docs/usetrackevent-react#parameters
  // otherwise the optimizely will simply ignore them
  const tags = eventProps
    ? {
        $opt_event_properties: eventProps,
      }
    : undefined;

  // @ts-expect-error optimizely type of event track doesn't match
  // the expected type https://github.com/optimizely/react-sdk/issues/303
  // TODO: remove after upgrade of optimizely sdk
  // Ticket: https://shippo.atlassian.net/browse/WEB-3719
  optimizelyClient?.track(eventKey, undefined, undefined, tags);
};
